import {
  getOrderSettings as publicGetOrderSettings,
  updateOrderSettings as publicUpdateOrderSettings,
  listOrderSettings as publicListOrderSettings,
} from './restaurants-ordersettings-v3-order-settings-order-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getOrderSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetOrderSettings> &
    typeof publicGetOrderSettings
> = /*#__PURE__*/ createRESTModule(publicGetOrderSettings);
/** @internal */
export const updateOrderSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateOrderSettings> &
    typeof publicUpdateOrderSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateOrderSettings);
/** @internal */
export const listOrderSettings: MaybeContext<
  BuildRESTFunction<typeof publicListOrderSettings> &
    typeof publicListOrderSettings
> = /*#__PURE__*/ createRESTModule(publicListOrderSettings);

export {
  ApproximateAddresses,
  Type,
  TipsType,
  DayOfWeek,
  ChargeRoundingStrategy,
} from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';
export {
  OrderSettings,
  Policies,
  Policy,
  Tips,
  TippingRate,
  FutureOrdersSettings,
  Availability,
  TimePeriod,
  SpecialHourPeriod,
  GetOrderSettingsRequest,
  GetOrderSettingsResponse,
  UpdateOrderSettingsRequest,
  UpdateOrderSettingsResponse,
  ListOrderSettingsRequest,
  ListOrderSettingsResponse,
  UpdateOrderSettings,
  ListOrderSettingsOptions,
} from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';
export {
  ApproximateAddressesWithLiterals,
  TypeWithLiterals,
  TipsTypeWithLiterals,
  DayOfWeekWithLiterals,
  ChargeRoundingStrategyWithLiterals,
} from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';
